/**
 * Function to check if payment form exists and is valid
 * @param {object} formElm - form element to be validated
 * @return - true if valid, false if not
 *
 * example - macmillanLoader.isFormValid($('.formclassname'));
 */
const isFormValid = (formElm) => {
    if (formElm.length > 0) {
        return formElm.valid();
    }
}

/**
 * Function to append loader HTML in DOM for specified element
 * including adding aria attributes to the parent elment of loader
 * @param {object} el - element to append loader HTML in
 * @param {string} loaderText - text of loader message
 */
const addLoader = (el, loaderText) => {
    el.attr({
        "aria-live": "polite",
        "aria-busy": "true",
    });

    el.append(`
            <div class="loader has-overlay has-small-overlay has-white-overlay payment-page-loader js-macmillan-loader" role="alert">
                <div class="dot-container">
                    <div class="dot"></div>
                </div>
                <div class="loader-text">${loaderText}</div>
            </div>
        `);
}

/**
 * Function to remove loader HTML from DOM
 * including updating aria attribute to the parent element of loader
 * @param {object} el - element to remove the loader from
 */
const removeLoader = (el) => {
    el.attr("aria-busy", "false");
    el.find(".js-macmillan-loader").remove();
}

/**
 * Function to show/hide loader depending on the form validation
 * @param {object} appendToElm - element where loader elements should be appended to
 */
const showHideLoader = (appendToElm) => {
    // Check if loader is already present in the DOM to avoid duplicates, if so remove it
    if (appendToElm.find(".js-macmillan-loader").length > 0) {
        // remove loader from DOM
        removeLoader(appendToElm);
    }
    // Add loader to the DOM
    addLoader(appendToElm, "Loading, please wait...");
}

/**
 * Function to intiate the loader if the payment form is valid
 */
const initLoader = (macmillanForm) => {
    // Capture the payment button wrapper element
    let loaderAppendToElm = $(".paymentOuterCont");

    // Check if payment form has passed validation and is valid
    if (isFormValid(macmillanForm)) {
        // Add the loader to the payment button wrapper element
        showHideLoader(loaderAppendToElm);
    }
}

export default initLoader;